const PolicyData = [
  {
    id: 1,
    article: ` 

### Privacy

Kasowitz Benson Torres LLP is committed to protecting and respecting your privacy and personal information.

This privacy policy describes how we collect, use, retain and secure the personal information that you have provided to us.

From time to time, we may update our data privacy practices, and therefore we encourage you to review this page periodically for updates to our privacy policy.

### Collection and Use of Personal information

Personal information means any data which relates to a living individual who can be identified from that data which is in the possession of, or is likely to come into the possession of, Kasowitz, our representatives or our service providers.

We collect personal information in the course of providing legal services to clients and as provided by visitors to our website or other internet services.  The personal information that we collect and use depends on the nature of our relationship with you. We may use personal information for the following purposes:

  * Provision of legal services to you

  * Provision of information requested by you

  * Compliance with applicable laws and regulations

  * Management and administration of the firm

  * Recruitment/Employment

  * Marketing
    
### Transfer of Data

If you are a citizen of or reside in the European Union (“EU”), we may need to transfer your personal information to the United States, in order to use it for the purposes set forth above. Any transfer of your personal information outside the EU will be done in accordance with EU data protection laws.  

### Retention of Personal information

We may retain information provided by you, including personal information, for as long as necessary to comply with our legal obligations, or to achieve any of the purposes for which the information was originally collected.  Laws or regulations may set a minimum period for which we have to keep your personal information.

### Disclosure of Personal information to Third Parties

We may share your personal information with our third party service providers, subject to appropriate confidentiality, privacy and data security safeguards, where we believe it is necessary to provide a service that you have requested, or as permitted or required by law, or as otherwise authorized or directed by you.  

We may be required to share your personal information to the extent required by law, court process or regulation or to establish, exercise or defend our legal rights.

We never sell or trade your personal information to any third parties.

### Data Security

We maintain organizational, physical and technical security measures to protect personal information from accidental or unlawful destruction or loss, alteration, unauthorized disclosure or access consistent with applicable data protection laws.

### Your Rights Concerning Your Personal information

As it relates to each of the above purposes for which we collect, use or retain your personal information, you may have the following rights: 

  * the right to request access to your personal information and check that we are lawfully processing it;

  * the right to request that we correct your personal information if it is inaccurate or incomplete;

  * the right to request that we delete or remove your personal information from our systems where there is no good reason for us to continue to process it. Please note that there may be circumstances where you ask us to delete your personal information but we are legally entitled or required to retain it;

  * the right to object to, or request that we restrict, our processing of your personal information in certain circumstances, for example, if you would like us to establish its accuracy. Again, there may be circumstances where you object to, or ask us to restrict, our processing of your personal information but we are legally entitled or required to refuse that request;

  * in some circumstances, the right to request that we transmit your personal information to a third party;

  * the right to withdraw your consent to the processing of your personal information at any time. Please note, however, that we may still be entitled to process your personal information if we have another legitimate reason for doing so. For example, we may need to retain personal information to comply with a legal obligation; and
        
You can exercise the above rights by contacting us at [KoyoSoftwareSolutions@gmail.com](https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=aditya@abnca.in).

You also have the right to lodge a complaint with the relevant data protection regulator if you think that any of your rights have been infringed by us.

### Cookies

The Kasowitz website uses Google Analytics, a web analytics service provided by Google, Inc. (“Google”). Google Analytics sets two cookies in order to evaluate your use of the website and compile reports for us on activity on the website. We use Google Analytics to provide us with information about how you use our website, which we use to help us to improve our website.  For more information about how Google stores information collected by cookies, see Google’s Privacy Policy.

The information collected by these cookies is anonymized and limited to website use and performance, device operating system, browser type, internet service provider name and non-specific geographic location.

By using the Kasowitz website, you consent to the processing of data about you by Google in the manner and for the purposes set out above.

* If you are based in the European Union, we will only provide you with marketing materials if you consent to the receipt of such materials. You may opt out of receiving marketing materials at any time by contacting us at [KoyoSoftwareSolutions@gmail.com](https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=aditya@abnca.in).
        `,
  },
];

export default PolicyData;
